import { createCustomerInquiry, createCustomerReport, fetchContactPerson } from "../common/firebase/FirestoreService";
import CustomerInquiry from "../model/customer/CustomerInquiry";
import CustomerReport from "../model/customer/CustomerReport";
import { sendInquiryEmail } from "../common/firebase/Function";
import { ContactWorkType } from "../model/customer/ContactPerson";

/**
 * 신고 관리 답변 처리 함수
 * @async
 * @function sendCustomerReport
 * @param {CustomerInquiry} inquiry - 문의 데이터
 * @returns {Promise<boolean>}
 */
const sendCustomerReport = async (report: CustomerReport) => {
    // 담당자 이메일 조회
    const contactPerson = await fetchContactPerson(ContactWorkType.Report);

    // 신고 정보 생성
    await createCustomerReport(report);

    const titleForContactPerson = "[BBTech 홈페이지] 신고 접수 알림";
    const contentForContactPerson =
        `<p>신고가 접수되었습니다.</p>` +
        `<hr>` +
        `<p><strong>접수자:</strong> ${report.requestorName}<br>` +
        `<strong>이메일:</strong> ${report.email}<br>` +
        `<strong>휴대폰 번호:</strong> ${report.mobileNo}<br>` +
        `<strong>제목:</strong> ${report.title}<br>` +
        `<strong>내용:</strong><br>${report.contents}</p>`;

    const titleForCustomer = "[BBTech] 신고건이 정상적으로 접수되었습니다.";
    const contentForCustomer =
        `<p>고객님이 접수해주신 소중한 신고건이 정상적으로 접수되었습니다.</p>` +
        `<p>아래는 접수 내용입니다.</p>` +
        `<hr>` +
        `<p><strong>제목:</strong> ${report.title}<br>` +
        `<strong>내용:</strong><br>${report.contents}</p>`;

    // 담당자에게 접수 이메일 전송
    await sendInquiryEmail(contactPerson.email, titleForContactPerson, "", contentForContactPerson);
    // 고객에게 접수 확인 이메일 전송
    await sendInquiryEmail(report.email, titleForCustomer, "", contentForCustomer);
};

/**
 * 문의 관리 답변 처리 함수
 * @async
 * @function sendCustomerInquiry
 * @param {CustomerInquiry} inquiry - 문의 데이터
 * @returns {Promise<boolean>}
 */
const sendCustomerInquiry = async (inquiry: CustomerInquiry) => {
    // 담당자 이메일 조회
    const contactPerson = await fetchContactPerson(ContactWorkType.Inquiry);

    // 문의 정보 생성
    await createCustomerInquiry(inquiry);

    const titleForContactPerson = "[BBTech 홈페이지] 문의 접수 알림";
    const contentForContactPerson =
        `<p>문의가 접수되었습니다.</p>` +
        `<hr>` +
        `<p><strong>접수자:</strong> ${inquiry.requestorName}<br>` +
        `<strong>이메일:</strong> ${inquiry.email}<br>` +
        `<strong>제목:</strong> ${inquiry.title}<br>` +
        `<strong>내용:</strong><br>${inquiry.contents}</p>`;

    const titleForCustomer = "[BBTech] 문의건이 정상적으로 접수되었습니다.";
    const contentForCustomer =
        `<p>고객님이 접수해주신 소중한 문의건이 정상적으로 접수되었습니다.</p>` +
        `<p>아래는 접수 내용입니다.</p>` +
        `<hr>` +
        `<p><strong>제목:</strong> ${inquiry.title}<br>` +
        `<strong>내용:</strong><br>${inquiry.contents}</p>`;

    // 담당자에게 접수 이메일 전송
    await sendInquiryEmail(contactPerson.email, titleForContactPerson, "", contentForContactPerson);
    // 고객에게 접수 확인 이메일 전송
    await sendInquiryEmail(inquiry.email, titleForCustomer, "", contentForCustomer);
};

export { sendCustomerReport, sendCustomerInquiry }; 